// ------------------------------------
// Constants
// ------------------------------------
export const IMPORTANT_DATES_REQUEST_GET = 'IMPORTANT_DATES_REQUEST_GET';
export const IMPORTANT_DATES_RECEIVE_GET_SUCCESS = 'IMPORTANT_DATES_RECEIVE_GET_SUCCESS';
export const IMPORTANT_DATES_RECEIVE_GET_FAILURE = 'IMPORTANT_DATES_RECEIVE_GET_FAILURE';
